module.exports = __webpack_public_path__ + "img/ocoInfoBuy.06b8ba0a.svg";